import { sdk } from 'src/utilities/sdk';
import { InitiateAsyncTaskResponse } from 'src/utilities/useAsyncDownloadTask/useAsyncDownloadTask.utils';

const CORP_ADMIN_PATH = '/corp-admin';

export const getEmployeesCsvDownloadRequestEndpoint = (
  corpId: string
): string => `${CORP_ADMIN_PATH}/${corpId}/diners/download`;

export const getEmployeesCsvDownloadStatusEndpoint = (
  corpId: string,
  downloadRequestId: string
): string =>
  `${CORP_ADMIN_PATH}/${corpId}/diners/download/${downloadRequestId}`;

export async function requestEmployeesCsvDownload(
  corpId: string
): Promise<InitiateAsyncTaskResponse> {
  const response: InitiateAsyncTaskResponse = await sdk.http.post(
    getEmployeesCsvDownloadRequestEndpoint(corpId),
    {}
  );

  return {
    ...response,
    uri: getEmployeesCsvDownloadStatusEndpoint(corpId, response.id),
  };
}

export async function getEmployeesCsvFromS3(
  downloadUrl: string
): Promise<string> {
  // Presigned S3 URL, so a plain fetch is used to avoid sending SDK auth headers.
  const response = await fetch(downloadUrl);

  return response.text();
}
